import React, { useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import FPTextEditor from 'UI/components/molecules/FPTextEditor';
import { TINY_WITH_IMAGES_CONFIG, tinymceConfig } from 'UI/constants/config';
import { FeatureFlags } from 'UI/constants/featureFlags';
import { IMAGE_VALIDATION_TEXT, NOT_BASE64_IMAGE_VALIDATION } from 'UI/utils';

const NOTE_FIELD_KEY = 'notes';

export const SupportActivityNotesField = () => {
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();

  const tinyConfig = checkIfFeatureFlagEnabled(FeatureFlags.FeedbackNotesImagesSuport)
    ? TINY_WITH_IMAGES_CONFIG
    : tinymceConfig;

  const editorRef = useRef(null);
  const { register, unregister, watch, setValue, errors } = useFormContext();

  const isUploadingEditorTextImage = errors[NOTE_FIELD_KEY]?.message === IMAGE_VALIDATION_TEXT;

  const initEditor = (e, editor) => {
    editorRef.current = editor;
  };

  const handleEditorChange = editorValue => setValue(NOTE_FIELD_KEY, editorValue, true);

  useEffect(() => {
    register(NOTE_FIELD_KEY, NOT_BASE64_IMAGE_VALIDATION);

    return () => {
      unregister(NOTE_FIELD_KEY);
    };
  }, [register, unregister]);

  return (
    <FPTextEditor
      onInit={initEditor}
      config={tinyConfig}
      value={watch(NOTE_FIELD_KEY)}
      onChange={handleEditorChange}
      error={!!errors[NOTE_FIELD_KEY] && !isUploadingEditorTextImage}
      errorText={errors[NOTE_FIELD_KEY]?.message}
      helperText={isUploadingEditorTextImage ? IMAGE_VALIDATION_TEXT : ''}
    />
  );
};
